export default __webpack_public_path__ + "static/media/discounts-weekend-image.6a278d5a.svg";